import Web3 from "web3";
import {coinracer_abi} from "../blockchain/abi/coinracer_abi";
import {staking_abi} from "../blockchain/abi/staking_abi";
import {utils} from "../utils/utils";
import {TPoolboard} from "../store/reducers/DashboardSlice";
import { addresses,defaultChainId } from '../blockchain/constants';

export interface ITransactionUser {
    value: number | string;
    gas: number | string;
    gasPrice: number | string;
}

export class MetaMaskService {
    private web3;
    private account;
    balance: string | number;
    private tokenContract;
    private contract;

    constructor(reqAccount, address) {
        this.web3 = new Web3(reqAccount);
        this.account = {
            address: address[0],
        };
        this.balance = 0;
        this.tokenContract = new this.web3.eth.Contract(
            coinracer_abi,
            addresses.coinracerToken[defaultChainId]);
        this.contract = new this.web3.eth.Contract(staking_abi, addresses.stakingv2[defaultChainId]);
    }

    async setBalance(): Promise<number> {
        //Converto to uint256 and ceiling
        let amount = 0;
        try{
            amount  = Number(await this.tokenContract.methods.balanceOf(this.account.address)
            .call({from: this.account.address}));
        } catch(e) {
            console.log(e)
        }
        const balance = Math.floor(amount / (10 ** 18));
        this.balance = balance;
        return balance;
    }

    async getContractBalance(): Promise<number | string> {
        return await this.web3.eth.getBalance(addresses.stakingv2[defaultChainId]);
    }


    async Stake(tokensCount: string | number, poolId: number) {
        //Converting value to uint256
        const number = Web3.utils.toWei(Web3.utils.toBN(tokensCount), "ether");
        //Default Gas Limit
        let isApproved: boolean = true
        try {

            await this.tokenContract.methods.approve(addresses.stakingv2[defaultChainId], number).send({
                from: this.account.address
            })
            isApproved = true
        } catch (e) {
            isApproved = false
            console.log(e)
        }
        try {
            if (isApproved) {
                await this.contract.methods
                    .deposit(poolId, number)
                    .send({
                        from: this.account.address
                    });
            }
        } catch (e) {
            console.log(e)
        }
        return true;
    }
    async getUnlockTime(pid: number) : Promise<number> {
        const depositedTime = (await this.contract.methods.userInfo(pid, this.account.address).call()).timestamp;
        const currentDate: any = new Date();
        const startDate: any = new Date(depositedTime * 1000);
        const timeDiff = currentDate - startDate;
        const lockTime = (await (await this.getPoolInfo(pid)).lockTime);
        return (Number(lockTime)*1000 - timeDiff);
    }
    async Withdraw(poolId: number, amount: string | number): Promise<boolean> {
        
        console.log("Withdrawing",amount, poolId);
        const number = Web3.utils.toWei(Web3.utils.toBN(amount), "ether");
        if((await this.getWithdrawFee(poolId) != 0) && (await this.getUnlockTime(poolId) > 0)) {
            try {
                await this.contract.methods.emergencyWithdraw(poolId).send({from: this.account.address});
            } catch(e) {
                console.log(e);
                return false;
            }
        }
        else {
            try {
                await this.contract.methods
                    .withdraw(poolId, number)
                    .send({
                            from: this.account.address
                        }
                    );
            } catch (e) {
                console.log(e);
                return false;
            }
        }
        
        
        return true;
    }
    async Harvest(pid:number): Promise<boolean> {
        try {
            await this.contract.methods.claimReward(pid).send({from: this.account.address});
        } catch (e) {
            console.log(e)
            return false;
        }
        return true;
    }
    async getInvested(pid:number): Promise<number> {
        let invested = 0
        try {
            invested = Number(await this.contract.methods.deposited(pid, this.account.address).call())
        } catch (e) {
            console.log(e)
        }
        return Math.floor(invested / (10 ** 18))
    }

    async computeEarned(poolId: number): Promise<number> {
        
        const earned =  Number(await this.contract.methods.pending(poolId, this.account.address).call());
        return Math.floor(earned / (10 ** 18));
    }
    async getNetworkId(): Promise<number> {
        return await this.web3.eth.net.getId();
    }

    //
    async getPoolInfo(poolId : number) : Promise<TPoolboard>{
        
        const pool = await this.contract.methods.poolInfo(poolId).call();
        return{
            lockTime: pool.lockTime,
            apy: pool.apy,
            withdrawFee: pool.withdrawFee,
            stakedAmount: pool.stakedAmount,
            compoundedAmount:pool.compoundedAmount,
        };
    }

    async getPoolAPY(pid:number): Promise<number> {
        let apy = 0;
        try {
            apy = (await this.getPoolInfo(pid)).apy!;
        } catch (e) {
            console.log(e)
        }
        return apy;

    }

    async getPoolAmount(pid:number): Promise<number> {
        let amount = 0;
        try {
            amount = (await this.getPoolInfo(pid)).stakedAmount!;
            //console.log("getPoolAPY", pid, apy);
        } catch (e) {
            console.log(e)
        }
        return Math.floor(utils.BNtoNum(amount, 18));

    }
    async getWithdrawFee(pid:number): Promise<number> {
        let fee = 0;
        try {
            fee = (await this.getPoolInfo(pid)).withdrawFee!;
        } catch (e) {
            console.log(e)
        }
        return fee;

    }
    async Compound(poolId : number) : Promise<boolean> {
        try {
            await this.contract.methods.compound(poolId).send({from: this.account.address});
        } catch(e) {
            console.log(e)
            return false;
        }
        return true;
    }
}
